export const maxOrderHour = 17;
export const maxOrderMinute = 30;
export const minOrderHour = 10;
export const minOrderMinute = 0;
export const orderTimeStepInSeconds = 15 * 60;
export const orderCutoffHours = 7;
